/* 10-23 负责人「长按可以放大拖」（手机商品页加购区颜色小图，MORE IN 色系 / COLOR 两行，细节版块复制出来的那排也支持）：
   - 长按约 350ms：在这一行上方弹出大预览卡（这件的主图 + 款名 + 颜色名）；
   - 按住左右拖：预览换成手指下那一件，两行之间也能拖；拖到行外，预览保持最后一个；
   - 松手：预览收起，不跳转；
   - 轻点（没到长按）：照旧去那件商品；
   - 按下后还没到 350ms 就移动超过 8px：当作横滑这一行，不出预览，横滑照旧。
   只在触屏（hover: none 且 pointer: coarse）生效；touchmove 只挂在颜色区上，不影响整页滚动性能。样式见 bsd-colorpick-preview.css */
(function () {
  if (window.__bsdColorPeek) return;
  window.__bsdColorPeek = true;

  var SEL = '.bsd-colorpick__opt, .bsdp-also__chip';
  var LONG_MS = 350;
  var SLOP = 8;
  var EDGE = 12;
  var coarse = window.matchMedia('(hover: none) and (pointer: coarse)');
  var press = null;
  var suppressUntil = 0;
  var card, cardLow, cardHi, cardName, cardColor, cardSale, cardWas;
  var shownEl = null;

  function buildCard() {
    if (card) return;
    card = document.createElement('div');
    card.className = 'bsd-cpv';
    card.setAttribute('aria-hidden', 'true');
    card.innerHTML =
      '<div class="bsd-cpv__img"><img class="bsd-cpv__low" alt=""><img class="bsd-cpv__hi" alt=""></div>' +
      '<p class="bsd-cpv__name"></p><p class="bsd-cpv__color"></p>' +
      // 10-23 负责人「这个放大的也把价格也显示出来」：售价 + 划线价
      '<p class="bsd-cpv__price"><span class="bsd-cpv__sale"></span><s class="bsd-cpv__was"></s></p>';
    cardLow = card.querySelector('.bsd-cpv__low');
    cardHi = card.querySelector('.bsd-cpv__hi');
    cardName = card.querySelector('.bsd-cpv__name');
    cardColor = card.querySelector('.bsd-cpv__color');
    cardSale = card.querySelector('.bsd-cpv__sale');
    cardWas = card.querySelector('.bsd-cpv__was');
    cardHi.addEventListener('load', function () {
      if (cardHi.getAttribute('src')) cardHi.classList.add('is-ready');
    });
    document.body.appendChild(card);
  }

  // 细节版块那排是复制第二行生成的（没有 data-bsd-*），按链接找回加购区原来的小图拿数据
  function sourceOf(el) {
    if (el.classList.contains('bsdp-also__chip')) {
      var href = el.getAttribute('href');
      var list = document.querySelectorAll('.bsd-colorpick__opt');
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('href') === href) return list[i];
      }
    }
    return el;
  }

  // Shopify 图片地址把宽度换成 480，给预览卡用
  function upsize(url) {
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=480');
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function infoOf(el) {
    var src = sourceOf(el);
    var img = el.querySelector('img') || src.querySelector('img');
    var low = img ? img.currentSrc || img.src : '';
    var title = src.getAttribute('title') || '';
    var parts = title.split(' – ');
    return {
      low: low,
      hi: src.getAttribute('data-bsd-img') || upsize(low),
      name: src.getAttribute('data-bsd-name') || parts[0],
      color: src.getAttribute('data-bsd-color') || parts[1] || '',
      price: src.getAttribute('data-bsd-price') || '',
      compare: src.getAttribute('data-bsd-compare') || ''
    };
  }

  function headerBottom() {
    var h = document.querySelector('sticky-header, .header-section, .header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    if (pos !== 'sticky' && pos !== 'fixed') return 0;
    return Math.max(0, h.getBoundingClientRect().bottom);
  }

  // 卡片放在这一行上方、对准手指下那一个；上方被页头挡住就放到这一行下方；左右不出屏幕
  function place(el) {
    var row = el.closest('.bsd-colorpick__list, .bsdp-also__list') || el;
    var rr = row.getBoundingClientRect();
    var er = el.getBoundingClientRect();
    var w = card.offsetWidth;
    var h = card.offsetHeight;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var left = Math.min(Math.max(er.left + er.width / 2 - w / 2, EDGE), vw - w - EDGE);
    var top = rr.top - h - 10;
    if (top < headerBottom() + 8) top = Math.min(rr.bottom + 10, window.innerHeight - h - EDGE);
    card.style.left = Math.round(left) + 'px';
    card.style.top = Math.round(top) + 'px';
  }

  function show(el) {
    buildCard();
    if (shownEl !== el) {
      if (shownEl) shownEl.classList.remove('is-peek');
      shownEl = el;
      el.classList.add('is-peek');
      var info = infoOf(el);
      cardHi.classList.remove('is-ready');
      cardLow.src = info.low;
      cardHi.src = info.hi;
      if (cardHi.complete && cardHi.naturalWidth) cardHi.classList.add('is-ready');
      cardName.textContent = info.name;
      cardColor.textContent = info.color;
      cardSale.textContent = info.price;
      cardWas.textContent = info.compare;
      cardWas.hidden = !info.compare;
    }
    place(el);
    card.classList.add('is-on');
  }

  function hide() {
    if (card) card.classList.remove('is-on');
    if (shownEl) shownEl.classList.remove('is-peek');
    shownEl = null;
  }

  function cancel() {
    if (press && press.timer) clearTimeout(press.timer);
    press = null;
    hide();
  }

  function onStart(e) {
    if (!coarse.matches || e.touches.length !== 1) {
      cancel();
      return;
    }
    var el = e.target.closest && e.target.closest(SEL);
    if (!el) return;
    var t = e.touches[0];
    cancel();
    press = { x: t.clientX, y: t.clientY, el: el, active: false };
    press.timer = setTimeout(function () {
      if (!press) return;
      press.active = true;
      if (navigator.vibrate) {
        try { navigator.vibrate(10); } catch (err) {}
      }
      show(press.el);
    }, LONG_MS);
  }

  function onMove(e) {
    if (!press) return;
    var t = e.touches[0];
    if (!press.active) {
      if (Math.abs(t.clientX - press.x) > SLOP || Math.abs(t.clientY - press.y) > SLOP) cancel();
      return;
    }
    // 长按之后这次触摸不再滚动这一行和整页
    if (e.cancelable) e.preventDefault();
    var hit = document.elementFromPoint(t.clientX, t.clientY);
    var el = hit && hit.closest && hit.closest(SEL);
    if (el && el !== shownEl) show(el);
  }

  function onEnd(e) {
    if (!press) return;
    var wasActive = press.active;
    cancel();
    if (wasActive) {
      // 长按松手不算点击，不跳转
      if (e.cancelable) e.preventDefault();
      suppressUntil = Date.now() + 700;
    }
  }

  function bind(root) {
    if (!root || root.__bsdPeek) return;
    root.__bsdPeek = true;
    root.addEventListener('touchstart', onStart, { passive: true });
    root.addEventListener('touchmove', onMove, { passive: false });
    root.addEventListener('touchend', onEnd, { passive: false });
    root.addEventListener('touchcancel', onEnd, { passive: false });
  }

  function init() {
    document.querySelectorAll('.bsd-colorpick, [data-bsd-also]').forEach(bind);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (Date.now() < suppressUntil && e.target.closest && e.target.closest(SEL)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (coarse.matches && e.target.closest && e.target.closest(SEL)) e.preventDefault();
    },
    true
  );
  document.addEventListener(
    'dragstart',
    function (e) {
      if (e.target.closest && e.target.closest(SEL)) e.preventDefault();
    },
    true
  );
  document.addEventListener('visibilitychange', cancel);
  window.addEventListener('pagehide', cancel);

  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init, { once: true });
})();
